import React from 'react';
import styles from '../ReportCard.module.scss';
import play from 'assets/icons/play.png';

/**
 * Кнопка "Сканировать QR" с запросом разрешения камеры.
 *
 * @param {Object} props
 * @param {string}  props.label   — текст кнопки ("Сканировать QR" / "Сканировать")
 * @param {boolean} props.success — показывать "✅ Подтверждено"?
 * @param {Function} props.onScan — колбэк при нажатии (после получения разрешения)
 * @param {Function} props.onNotify
 */
const ScanButton = ({ label = 'Сканировать', success, onScan, onNotify }) => {
  const handleClick = async () => {
    if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
      try {
        // Запрашиваем заднюю камеру { exact } чтобы браузер сразу открыл нужную
        let stream = null;
        try {
          stream = await navigator.mediaDevices.getUserMedia({
            video: { facingMode: { exact: 'environment' } },
          });
        } catch (_) {
          // Fallback: ideal mode
          try {
            stream = await navigator.mediaDevices.getUserMedia({
              video: { facingMode: { ideal: 'environment' } },
            });
          } catch (_2) {
            stream = await navigator.mediaDevices.getUserMedia({ video: true });
          }
        }
        // Сразу останавливаем предварительный поток — useCamera сам стартует нужную
        if (stream) stream.getTracks().forEach(t => t.stop());
        onScan();
      } catch (err) {
        onNotify({
          isOpen: true,
          message: 'Разрешите доступ к камере для сканирования QR-кода!',
          type: 'error',
        });
      }
    } else {
      onNotify({
        isOpen: true,
        message: 'Ваше устройство не поддерживает доступ к камере!',
        type: 'error',
      });
    }
  };

  return (
    <>
      <button onClick={handleClick} className={styles.btn_tabel}>
        {label} <img className={styles.image_icon} src={play} alt="" />
      </button>
      {success && (
        <div style={{ color: 'green', fontWeight: 'bold', marginTop: 10, fontSize: 16 }}>
          ✅ Подтверждено
        </div>
      )}
    </>
  );
};

export default React.memo(ScanButton);
